import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom'; 

const useStyles = makeStyles({
    upperFooter: {
        backgroundColor: 'var(--primary-color)', /*rgb(51, 51, 51);*/
        textAlign: 'center',
        color: 'white',
        padding: '40px 0',
        '& img': {
            maxHeight: '40px',
            marginBottom: '20px'
        },
        '& p': {
            marginBottom: '0',
            maxWidth: '700px',
            marginLeft: 'auto',
            marginRight: 'auto',
            fontSize: '13px',
            '& .footer-link': {
                color: 'white',
                '&:hover': {
                    color: '#ddd',
                }
            }
        }
    },
    lowerFooter: {
        backgroundColor: '#03422c', /* rgb(36, 36, 36); */
        padding: '20px 0',
        color: 'white',
        textAlign: 'center',
        '& p': {
            marginBottom: '0',
            fontSize: '0.8rem',
            '@media screen and (max-width: 480px)': {
                fontSize: '13px',
            }
        }
    },
});

  
function Footer() {
    var classes = useStyles();

    return (
        <footer>
            <div className={classes.upperFooter}>
                <div className="container">
                    <img src="/pitchbattle/images/nxg-logo-white.png" alt=""/>
                    <p>For any support, please mail to <a className="footer-link" href="mailto:info@nxg.co.in">info@nxg.co.in</a>. Our support team will get back to you within 24 hours.</p>
                    {/* Add links for privacy policy, terms & conditions, and refund policy */}
                    <br />
                    <p>
                        <a href="/#contact" className="footer-link">Contact Us</a> |&nbsp; 
                        <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link> |&nbsp; 
                        <Link to="/terms-conditions" className="footer-link">Terms & Conditions</Link> |&nbsp; 
                        <Link to="/refund-policy" className="footer-link">Refund Policy</Link> |&nbsp; 
                        <Link to="/shipping" className="footer-link">Shipping Policy</Link>
                    </p>
                </div>
            </div>
            <div className={classes.lowerFooter}>
                <div className="container">
                    <p> ©️ 2024 Acadverse Technologies Private Limited. All rights reserved.</p>
                </div>
            </div>
        </footer>
    )
}

export default Footer;